<template>
   <BlockUI :blocked="blockedDocument" :fullScreen="true"></BlockUI>
   <template v-if="mostrarDetalle">
      <ResultCardCampana
         ref="resultCardCampana"
         :resultData="resultData"
         :descripcion="descripcion"
         :idProcesoGeneral="idProcesoGeneral"
         :secondary="secondary"
         :addAjax="addAjax"
         :removeAjax="removeAjax"
         :load500Error="load500Error"
      ></ResultCardCampana>
   </template>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import FiltersDataService from "@/service/FiltersDataService";
import FiltersService from "@/service/FiltersService";
import ResultCardCampana from "@/components/ResultCardCampana.vue";

const idContabilidad = ref(null);
const blockedDocument = ref(true);
const mostrarDetalle = ref();

const resultData = ref();
const resultCardCampana = ref();

const ajaxRunningCount = ref(0);

const router = useRouter();
const route = useRoute();

let procesosGenerales = ref([]);
let idProcesoGeneral = ref();
let descripcion = ref(null);

const secondary = ref(false);
const backendChecked = ref(false);

onMounted(() => {
   checkBackend();
   /*FiltersDataService.getInfo()
      .then((res) => {
         console.log(res.data);
         idContabilidad.value = route.params.idContabilidad;
         getDetalle();
      })
      .catch((err) => {
         console.error(err);
         loadBackError(err);
      });*/
});

const checkBackend = () => {
   //console.log("checkBackend: " + secondary.value);
   if (!backendChecked.value) {
      FiltersDataService.getInfo(secondary.value)
         .catch((err) => {
            if (!secondary.value) {
               secondary.value = true;
               checkBackend();
            } else {
               loadBackError(err);
            }
         })
         .finally(() => {
            backendChecked.value = true;
            init();
         });
   } else {
      init();
   }
};

const init = () => {
   idContabilidad.value = route.params.idContabilidad;
   getDetalle();
};

const getDetalle = () => {
   addAjax();
   const params = FiltersDataService.setFilters(
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      null,
      idContabilidad.value
   );
   FiltersDataService.getContabilidades(secondary.value, params)
      .then((res) => {
         const array = res.data.body;
         resultData.value = array[0];
         idProcesoGeneral.value = resultData.value.ID_PROCESO_GENERAL;
         console.log(resultData.value);
         mostrarDetalle.value = 1;
         getProcesosElectorales();
      })
      .catch((err) => {
         console.log("Error en lista");
         console.log(err);
      })
      .finally(() => {
         removeAjax();
      });
};

const getProcesosElectorales = () => {
   addAjax();
   FiltersDataService.getProcesosElectorales(secondary.value, resultData.value.ID_PROCESO, resultData.value.ID_PROCESO_ELECTORAL)
      .then((res) => {
         procesosGenerales.value = res.data.body;
         setProcesoElectoral();
         removeAjax();
      })
      .catch((err) => {
         removeAjax();
         console.log(err);
         load500Error(err);
      });
};

const setProcesoElectoral = () => {
   if (procesosGenerales.value.length > 0) {
      const previousId = idProcesoGeneral.value;
      const searchItem = FiltersService.findProcesoElectoral(procesosGenerales.value, previousId);
      if (searchItem == undefined) {
         load500Error("No se encontró el proceso general indicado en la contabilidad");
      } else {
         idProcesoGeneral.value = searchItem.ID_PROCESO_GENERAL;
         descripcion.value = searchItem.DESCRIPCION;
      }
   } else {
      load500Error("No se encontró la lista de procesos generales");
   }
};

const loadBackError = (err) => {
   router.push({ name: "LoadBackError", replace: true, params: { error: err } });
   resetAjax();
};

const checkAjax = () => {
   if (ajaxRunningCount.value == 0) blockedDocument.value = false;
   else blockedDocument.value = true;
};

const addAjax = () => {
   ajaxRunningCount.value = ajaxRunningCount.value + 1;
   checkAjax();
};

const removeAjax = () => {
   ajaxRunningCount.value = ajaxRunningCount.value - 1;
   checkAjax();
};

const load500Error = (err) => {
   router.push({ name: "Error500", replace: true, params: { error: err } });
   resetAjax();
};

const resetAjax = () => {
   ajaxRunningCount.value = 0;
   checkAjax();
};
</script>
